import { rtrTasksSlice } from "./rtrTasksSlice";
import * as actions from "./rtrTasksActions";
import * as selectors from "./rtrTasksSelectors";

export { actions };
export { selectors };
export default rtrTasksSlice.reducer;
